import { get, post } from '@/common/request';
import { Group, Label, PlaceInfo } from './place';
import { RoleInfo } from './roleSet';
// 请不要再往这里塞api，用规范写法，不懂就问！
const pointMap = new Map<string, string>([
  ['copy', '/tenant/spot/fastCreate'],
  ['add', '/property/spot/create'],
  ['detail', '/tenant/spot/detail'],
  ['analysis', '/tenant/spot/detail/analysis'],
  ['edit', '/property/spot/update'],
  ['config', '/tenant/init/spot/config'],
  ['roleList', '/tenant/spot/role/relation/list'],
  ['deleteRole', '/tenant/role/relation/delete'],
  ['addRole', '/tenant/role/relation/add'],
  ['spotPriceDetail', '/tenant/spot/price/detail'],
  ['spotPriceEdit', '/tenant/spot/price/create'],
  ['spotEamineOrderDetail', '/tenant/examineOrder/spot/detail/analysis'],
  ['spotOrderQuoteCreate', '/tenant/order/quote/create'],

  // charts
  ['charts', '/tenant/ads/orderDataAnalysis'],

  // Cooperation
  ['dwsQuoteList', '/tenant/ads/getDwsQuoteList'],
  ['dwsDealList', '/tenant/ads/getDwsDealList'],
  ['dwsLandedList', '/tenant/ads/getDwsLandedList']
]);

export interface SearchParams {
  placeName?: string;
  placeCategoryIdList?: number[],
  placeLabelIdList?: number[],
  spotName?: string;
  spotCode?: number;
  spotCategoryIdList?: number[],
  role?: {
    roleId?: number,
    employeeIdList?: number[]
  },
  indoorOrOutdoor?: number,
  spotAreaRange?: Range;
  publishPrice?: Range;
  onShelvesStatus?: number,
  reviewStatus?: number,
  editStatus?:number,
  isInReview?: number,
  spotLabelIdList?: number[]
}


export interface SpotInfo {
  tenantSpotId?: number;
  spotCode?: number;
  spotName?: string;
  spotLW?: string;
  weekdayPrice?: string,
  weekdayFlow?: string;
  spotDescription?: string;
  spotCategoryId?: number;
  spotCategoryName?: number;
  onShelvesStatus?: number;
  reviewStatus?: number;
  editStatus?:number;
  onlineDate?: string;
  onlineEmployeeId?: number;
  onlineEmployeeName?: number;
  offlineReason?: string;
  offlineEmployeeId?: number;
  offlineEmployeeName?: string;
  placeRoleRelationList?: number[];
  indoorOrOutdoor?: {
    selectedId?: number;
    name?: string;
    input?:string
  };
  spotArea?: string;
  publishPrice?: number;
  spotFloor?: string;
  tenantPlaceId?: number;
  placeName?: string;
  placeCategoryId?: number;
  placeCategoryName?: string;
  spotLabelList?: Label[];
  workdayDayAvg?: number;
  spotPanorama?: File[]
  spotPicture?: File[]
  spotVideo?: File[]
  floorPlan?: File[]
  topPropertyList?: any[]
}

interface Response {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: SpotInfo[]
  records?:SpotInfo[]
}

export interface CreateInfo {
  placeName: string;
  placeCategoryId: number,
  area: {
    provinceId: number,
    cityId: number,
    districtId: number
  },
  address: {
    address: string,
    longitude: number,
    latitude: number,
    poiId: number,
    poiName: number
  }
}

interface Respone {
  independentSpot?: number;
  resourceGroupList?: Group[];
  placeBasicInfo?: PlaceInfo;
  spotBasicInfo?: SpotInfo;
  onShelvesStatus?: number;
  permissions?: any[];
  tabs?: any[];
  spotPublicId?: any;
}


export interface DetailInfo extends SpotInfo {
  propertyValueList: PropertyValue[];
  categoryId?: number;
}

export interface PropertyValueEdit {
  propertyId: number;
  textValue?: any;
}

export interface PropertyValue extends PropertyValueEdit {
 categoryPropertyGroupId?: number;
 categoryPropertyGroupConfigId?: number;
 categoryPropertyGroupConfigIdentification?: string;
 controlType?: number;
 propertyValueOptionList?: any[];
}

export interface Config {
  labelValue?: string,
  labelName?: string,
  type?: string,
  suffix?: null,
  optionList?: {
      name?: string,
      value?: string
    }[],
}


interface RoleItem extends RoleInfo {
  employeeList?: {
    employeeId: number,
    employeeName: string,
    mobile: string;
  }[]
}

export interface Price {
  weekdayPrice?: number,
  weekendPrice?: number,
  holidayPrice?: number,
  singleWeekPrice?: number,
  doubleWeekPrice?: number,
  singleNineDayPrice?: number,
  doubleNineDayPrice?: number,
  monthlyPrice?: number,
  fridayPrice?: number,
  deposit?: number,
  approvalFee?: string,
  sundryFee?: string,
  remark?: string,
}

// 图标类型
type ChartsType = 'INVERSION_RATE' | 'TRANSACTION_AMOUNT' | 'CUSTOMER_LEVEL' | 'INDUSTRY'
// 类型 - 合作情况转化率：INVERSION_RATE，成交金额：TRANSACTION_AMOUNT，客户等级：CUSTOMER_LEVEL，客户行业：INDUSTRY

// 合作情况

interface Quote {
  number?: number; // 需求编号
  spotId?: number; // 点位id
  placeId?: number; // 场地id
  enterpriseName?: string; // 客户
  name?: string; // 需求名称
  brandName?: string; //  品牌名称
  product?: string; // 产品
  scheduleList?: any[]; // 档期（按天）
  schedule?: string; // 档期
  price?: string // 报价信息
}

interface Deal {
  orderNum?: number; // 订单号
  spotId?: number; // 点位ID
  placeId?: number; //  场地ID;
  requirementId?: number; // 需求ID
  companyName?: string; // 客户
  name?: string; //  活动名称
  brandName?: string; // brandName
  product?: string; // 产品
  schedule?: string; // 档期
  dealPrice?: number; // 成交价
  }


export function postTenantSpotPage(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return post('/property/spots', { page, size, ...searchParams }, { needHint: true });
}

/* 展位位列表
 * https://yapi.lanhanba.com/project/319/interface/api/48663
*/
export function postBoothsPage(params:any): Promise<Response> {
  return post('/tenant/spot/page/booths', params, { needHint: true, proxyApi: '/resserv' });
}

/* 广告位列表
 * https://yapi.lanhanba.com/project/319/interface/api/48775
*/
export function postTenantAdsPage(params): Promise<Response> {
  return post('/tenant/spot/page/ads', params, { needHint: true, proxyApi: '/resserv' });
}

/* 商铺列表
 * https://yapi.lanhanba.com/project/319/interface/api/53080
*/
export function postBunkPCPage(params): Promise<Response> {
  return post('/tenant/spot/page/bunk', params, { needHint: true, proxyApi: '/resserv' });
}


export function postSpotPage(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return post('/spot/page', { page, size, ...searchParams }, { needHint: true, proxyApi: '/resserv' });
}

export function add(info: CreateInfo): Promise<any> {
  return post('/property/spot/create', info, { needHint: true });
}

export function deleteSpot(tenantSpotId: number): Promise<boolean> {
  return post('/tenant/spot/delete', { tenantSpotId }, { needHint: true, proxyApi: '/resserv' });
}

export function copyByRes(spotIdList: number[]): Promise<boolean> {
  return post('/tenant/spot/fastCreate', { spotIdList }, { needHint: true, proxyApi: '/resserv' });
}

export function getInfoBytenantSpotId(tenantSpotId: number): Promise<DetailInfo> {
  return post('/tenant/spot/show', { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
}

export function getAnalysisBytenantSpotId(tenantSpotId: number, reviewPage = false): Promise<Respone> {
  return post('/tenant/spot/detail/analysis', { tenantSpotId, reviewPage }, { proxyApi: '/resserv', needHint: true });
}

export function getSpotEamineOrderDetailBytenantSpotId(tenantSpotId: number): Promise<Respone> {
  return post('/tenant/examineOrder/spot/detail/analysis', { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
}

export function edit(params): Promise<boolean> {
  return post('/property/spot/update', params, { needHint: true });
}

export function getConfig(): Promise<{conditionList: Config[]}> {
  return post('/tenant/init/spot/config', {}, { proxyApi: '/resserv', needHint: { needHint: true, proxyApi: '/resserv' } });
}

export function getRoleList(params): Promise<RoleItem[]> {
  return post('/tenant/spot/role/relation/list', params, { proxyApi: '/resserv', needHint: true });
}

export function deleteRole(tenantSpotId: number, roleId: number, employeeId: number) {
  return post('/tenant/role/relation/delete', { tenantSpotId, roleId, employeeId }, { proxyApi: '/resserv', needHint: true });
}

export function addRole(tenantSpotId: number, roleId: number, employeeIdList: number[], type: number) {
  return post('/tenant/role/relation/add', { tenantSpotId, roleId, employeeIdList, type }, { proxyApi: '/resserv', needHint: true });
}

export function getPlaceRoleList(tenantPlaceId: number): Promise<RoleItem[]> {
  return post('/tenant/place/role/relation/list', { tenantPlaceId, type: 0 }, { proxyApi: '/resserv', needHint: true });
}

export function deletePlaceRole(tenantPlaceId: number, roleId: number, employeeId: number) {
  return post('/tenant/role/relation/delete', { tenantPlaceId, roleId, employeeId, type: 0 }, { proxyApi: '/resserv', needHint: true });
}

export function addPlaceRole(tenantPlaceId: number, roleId: number, employeeIdList: number[], type: number) {
  return post('/tenant/role/relation/add', { tenantPlaceId, roleId, employeeIdList, type }, { proxyApi: '/resserv', needHint: true });
}

export function getSpotPriceDetail(tenantSpotId: number): Promise<Price> {
  return post('/tenant/spot/price/detail', { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
}

export function getCharts(tntResourceId: number, resourceType: 0 | 1, typeList: ChartsType[]): Promise<any> {
  return post('/tenant/ads/orderDataAnalysis', { tntResourceId, resourceType, typeList }, { proxyApi: '/resserv', needHint: true });
}

export function getQuoteList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Quote[], page: number, size: number}> {
  return post(pointMap.get('dwsQuoteList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function getDealList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Deal[], page: number, size: number}> {
  return post(pointMap.get('dwsDealList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function getLandedList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Deal[], page: number, size: number}> {
  return post(pointMap.get('dwsLandedList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

/* 总订单量&交易额*/
// https:// yapi.lanhanba.com/mock/399/api/tenant/ads/total/analysis
export function getStatisticsOfTransactions(tntResourceId: string, resourceType: string) {
  return post('/tenant/ads/total/analysis', { tntResourceId, resourceType }, { proxyApi: '/resserv', needHint: true });
}

/**
 * 变更记录列表（场地、点位）
 * https://yapi.lanhanba.com/project/399/interface/api/42741
 */
export function getResourceChangeRecords(params) {
  return post('/tenant/changeRecord/page', params, {
    isMock: false,
    needHint: true,
    proxyApi: '/resserv'
  });
}

/**
 * 变更记录详情（场地、点位）
 * https://yapi.lanhanba.com/project/399/interface/api/42748
 */
export function getResourceChangeDetail(params) {
  return post('/tenant/changeRecord/detail', params, {
    isMock: false,
    needHint: true,
    proxyApi: '/resserv'
  });
}

/**
 * 点位价格完善情况（成本价和售价）
 * https://yapi.lanhanba.com/project/399/interface/api/59219
 */
export function getPriceExists(params: any) {
  return post('/tenant/spot/price/exists', { ...params }, { proxyApi: '/resserv' });
}

export function getSpotAppCode(params): Promise<Response> {
  return get('/property/spots/appCode', params, false);
}

/**
 * 点位列表动态表头
 * https://yapi.lanhanba.com/project/399/interface/api/62411
 */
export function getSpotDynamicColumns(params: any) {
  return post('/tenant/dynamicsTable/list', { ...params }, { proxyApi: '/resserv' });
}


/**
 * 点位列表表单动态筛选项
 * https://yapi.lanhanba.com/project/319/interface/api/65015
 */
export function postSpotDynamicFilter() {
  return post('/property/spot/dynamicFilter', { }, true);
}

/**
 * 历史交易-活动效果列表
 * https://yapi.lanhanba.com/project/319/interface/api/65015
 */
export function getHistoryActivityList(params: any) {
  return post('/tenant/ads/getOrderEffectPage', { ...params }, { proxyApi: '/resserv', needCancel: false });
}

/**
 * 历史交易-活动效果详情
 * https://yapi.lanhanba.com/project/319/interface/api/65015
 */
export function getHistoryActivityDetail(params: any) {
  return post('/tenant/ads/getOrderEffect', { ...params }, { proxyApi: '/resserv', needCancel: false });
}

/**
 * 获取点位下的门店列表
 * https://yapi.lanhanba.com/project/399/interface/api/65904
 */
export function getHistorySpotList(params: any) {
  return get('/tenant/spot/stores', { ...params }, { proxyApi: '/resserv', needCancel: false });
}

/**
 * 获取踩点任务的小时维度数据
 * https://yapi.lanhanba.com/project/399/interface/api/65687
 */
export function getCheckTaskDetail(params: any) {
  return get('/tenant/spot/check_spot_hour_data', { ...params }, { proxyApi: '/resserv', needCancel: false });
}

/**
 * 活动效果品牌列表
 * https://yapi.lanhanba.com/project/399/interface/api/65904
 */
export function getActivityBrandList(params: any) {
  return post('/tenant/ads/getOrderEffectBrandList', { ...params }, { proxyApi: '/resserv', needCancel: false });
}

export default pointMap;
